<template>
    <div class="comLegend chartConfig_viewDP">
        <div class="chartDivConfig checkViewConfig">
            <el-checkbox v-model="config.legend.show" @change="getRender">是否展示图例</el-checkbox>
        </div>
        <div class="chartDivConfig colViewConfig">
            <span class="span_til">字体颜色</span>
            <el-color-picker v-model="config.legend.font.color" show-alpha @change="getRender"></el-color-picker>
        </div>
        <div class="chartDivConfig numViewConfig numViewConfig_unit">
            <span class="span_til">字体大小</span>
            <el-input v-model="config.legend.font.size" @change="getRender" type="number" min="12"></el-input>
            <div class="unit">px</div>
        </div>
        <div class="chartDivConfig numViewConfig numViewConfig_unit">
            <span class="span_til">图例间隔</span>
            <el-input v-model="config.legend.marInterval" @change="getRender" type="number"></el-input>
            <div class="unit">px</div>
        </div>
        <div class="chartDivConfig selViewConfig">
            <span class="span_til">图例排列</span>
            <el-select v-model="config.legend.orient" placeholder="请选择位置"
                       :popper-append-to-body="false" @change="getRender">
                <el-option
                        v-for="item in orientList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
            </el-select>
        </div>
        <div class="chartDivConfig selViewConfig">
            <span class="span_til">图例位置</span>
            <el-select v-model="config.legend.position" placeholder="请选择位置"
                       :popper-append-to-body="false" @change="getRender">
                <el-option
                        v-for="item in positionList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
            </el-select>
        </div>
    </div>
</template>

<script>
    /**
     @author xiaoye
     @date 2020/4/27 5:22 下午
     */
    export default {
        name: 'comLegend',
        components: {},
        props: {
            name: {
                type: String,
                default: ''
            },
            type: {
                type: String,
                default: ''
            },
        },
        data() {
            return {
                //位置
                positionList: [
                    {value: 'top', label: '上方'},
                    {value: 'bottom', label: '下方'},
                    {value: 'left', label: '左边'},
                    {value: 'right', label: '右边'},
                    {value: 'leftTop', label: '左上方'},
                    {value: 'leftBottom', label: '左下方'},
                    {value: 'rightTop', label: '右上方'},
                    {value: 'rightBottom', label: '右下方'},
                ],
                // 排列方式
                orientList:[
                    {value: 'horizontal', label: '水平'},
                    {value: 'vertical', label: '垂直'},
                ]
            }
        },
        computed: {
            config() {
                if (this.type === 'view') {
                    return this.$store.state.viewDP.chart.setting.params;
                } else if (this.type === 'screen') {
                    return this.$store.state.designer.chart.setting.params;
                }
            }
        },
        methods: {
            getRender() {
                if (this.type === 'view') {
                    this.$store.dispatch('viewDPRender');
                } else if (this.type === 'screen') {
                    this.$store.dispatch('screenRender');
                }
            },
        },
        mounted() {

        },
        destroyed() {

        }
    }
</script>

<style lang="less">
    .comLegend {

    }
</style>
